import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { ButtonWrapper } from "@insite/mobius/Button";
import Icon from "@insite/mobius/Icon";
import Link, { StyledIcon } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
// eslint-disable-next-line spire/fenced-imports
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import getColor from "@insite/mobius/utilities/getColor";
import generatePdf from "@tSurya/Handlers/GeneratePdfHandler";
import Download from "@tSurya/MobiusOverrides/Icons/Download";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { buttonStyles } from "@tSurya/StylesExtensions/IconStyle";
import parse from "html-react-parser";
import * as React from "react";
import { useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import tearSheetDownload from "@tSurya/Handlers/SURDownloadTearSheet";

const mapStateToProps = (state: CustomApplicationState) => ({
    productDataPoint: state.SURData.productDataPointContent,
    tearSheet: state.context.settings.properties.downloadTearsheet,
    isdownloadtearsheet:state.SURData.downloadTearSheetReducer.downloadtearsheet
});
const mapDispatchToProps = { generatePdf,tearSheetDownload };

type Props = HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PdpAccordionSectionStyles {
    accordionContainer?: InjectableCss;
    featuresContainer?: InjectableCss;
    documentName?: InjectableCss;
    button?: InjectableCss;
    table?: InjectableCss;
    download?: InjectableCss;
    tablediv?: InjectableCss;
    lastUpdate?: InjectableCss;
    lastUpdateLable?: InjectableCss;
    lastUpdateDate?: InjectableCss;
    accordianSection?: InjectableCss;
    accordian?: AccordionSectionPresentationProps;
    documentsWrapper?: InjectableCss;
    resourceContainer?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    modalStyles?: ModalPresentationProps;
    modalStylesLandscape?: ModalPresentationProps;
}

export const PdpAccordionSectionStyles: PdpAccordionSectionStyles = {
    modalStyles: {
        sizeVariant: "large",
        cssOverrides: {
            modalContent: css`
                > div {
                    padding-bottom: 56.2%;
                    position: relative;
                }
            `,
            modalBody: css`
                max-width: 860px !important;
            `,
            modalContainer: css`
                iframe {
                    position: absolute;
                }
            `,
        },
    },
    modalStylesLandscape: {
        sizeVariant: "large",
        cssOverrides: {
            modalBody: css`
                max-width: 860px !important;
            `,
            modalContainer: css`
                iframe {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                aspect-ratio: 16 / 9;
                            `,
                            css`
                                aspect-ratio: 16 / 9;
                            `,
                            css`
                                aspect-ratio: 16 / 9;
                            `,
                            css`
                                aspect-ratio: 16 / 9;
                            `,
                            css`
                                height: 67.5vh !important;
                                max-height: 591px !important;
                            `,
                        ])};
                }
            `,
        },
    },
    accordionContainer: {
        css: css`
            margin-top: 47px !important;
            margin-bottom: 38px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 28px !important;
                        margin-bottom: 28px !important; ;
                    `,
                    css`
                        margin-top: 28px !important;
                        margin-bottom: 28px !important; ;
                    `,
                    css`
                        margin-top: 28px !important;
                        margin-bottom: 28px !important; ;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    featuresContainer: {
        css: css`
            p {
                padding-left: 20px;
                margin-bottom: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding-left: 0px;
                        `,
                        css`
                            padding-left: 0px;
                        `,
                        css`
                            padding-left: 20px;
                        `,
                        null,
                        null,
                    ])};
            }
            > ul {
                /* font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.lsmall}; */
                color: ${getColor("text.main")} !important;
                /* color: ${getColor("text.link")}; */
                margin: 0px !important;
                padding-top: 20px;
                > li {
                    //color: ${getColor("text.main")} !important;
                    /* color: ${getColor("text.link")}; */
                }
            }
        `,
    },
    button: {
        css: css`
            display: flex;
            align-items: center;
            padding: 10px 40px;
            text-align: center;
            gap: 15px;
            border: 2px solid ${getColor("text.accent")};
            background-color: ${getColor("primary.contrast")};
            span {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${getColor("text.main")};
                text-align: center;
                background-color: ${getColor("primary.contrast")};
            }
        `,
    },
    download: {
        css: css``,
    },
    tablediv: {
        css: css`
            overflow-x: scroll;
        `,
    },
    lastUpdate: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    lastUpdateLable: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: ${TYPOGRAPHY.lineHeight.medium};
            text-align: center;
            color: ${getColor("text.main")};
            margin-bottom: 19px;
        `,
    },
    lastUpdateDate: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: ${TYPOGRAPHY.lineHeight.medium};
            text-align: center;
            color: ${getColor("text.main")};
            margin-bottom: 19px;
            font-weight: bold;
        `,
    },
    accordianSection: {
        css: css`
            margin-bottom: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 14px;
                    `,
                    css`
                        margin-bottom: 14px;
                    `,
                    css`
                        margin-bottom: 14px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    accordian: {
        headerProps: {
            css: css`
                button {
                    padding: 10px 20px;
                    border: 0;
                    background-color: ${getColor("common.backgroundContrast")};
                    /* background-color: ${getColor("text.link")}; */
                    > span:first-of-type {
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-style: normal;
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        font-size: ${TYPOGRAPHY.size.large};
                        line-height: ${TYPOGRAPHY.lineHeight.medium};
                        color: ${getColor("text.main")};
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                border: 0;
            `,
        },
    },
    documentsWrapper: {
        css: css`
            padding: 20px;
        `,
    },
    resourceContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
};

const styles = PdpAccordionSectionStyles;
const customStyleButton = buttonStyles;

const PdpAccordionSection: React.FC<Props> = ({ product, productDataPoint, tearSheet, generatePdf,isdownloadtearsheet,tearSheetDownload }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [videoLink, setVideoLink] = useState("");
    const [isViewPortrait, setIsViewPortrait] = useState(true);
    const [isAccordionExpanded, setAccordionExpanded] = React.useState(false);
    const tearsheetArr = tearSheet.split(",");
    const lowercaseTearsheetArr = tearsheetArr.map(item => item.toLowerCase());

    const doesProductTypExists = lowercaseTearsheetArr?.includes(product?.properties?.productType.toLocaleLowerCase());

    React.useEffect(() => {
        const handleOrientationChange = (e: { matches: any }) => {
            const portrait = e.matches;
            if (portrait) {
                setIsViewPortrait(true);
            } else {
                setIsViewPortrait(false);
            }
        };

        const mediaQuery = window.matchMedia("(orientation: portrait)");
        mediaQuery.addEventListener("change", handleOrientationChange);

        return () => {
            mediaQuery.removeEventListener("change", handleOrientationChange);
        };
    }, []);

    React.useEffect(() => {
        const anchorTagWithYouTubeLink = document.querySelector("a[href*='youtube.com']") as HTMLAnchorElement;
        if (anchorTagWithYouTubeLink) {
            anchorTagWithYouTubeLink.style.textDecoration = "underline";
            const link: any = anchorTagWithYouTubeLink.getAttribute("href");
            const exactlink = link?.replace(/"/g, "");
            setVideoLink(exactlink);
            anchorTagWithYouTubeLink.addEventListener("click", handleOpenModal);
        }

        return () => {
            if (anchorTagWithYouTubeLink) {
                anchorTagWithYouTubeLink.removeEventListener("click", handleOpenModal);
            }
        };
    }, [productDataPoint.productContentResults]);

    const handleOpenModal = (event: any) => {
        event.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    if (!product?.content || !product.specifications || !product.attributeTypes) {
        return null;
    }
    const features = (product.specifications ?? []).filter(specification => {
        return specification.name === "Features";
    });
    const productDocument = product.documents && product.documents.length > 0;

    const endingTerms = product.productNumber?.endsWith("_P") ? "_P" : "-P";
    const contentParams = product.productNumber?.endsWith(endingTerms)
        ? product.productNumber?.replace(endingTerms, "")
        : product.productNumber;
    const toasterContext = useContext(ToasterContext);

    const productNumberWithOutSuffix = product?.properties?.productNumberWithOutSuffix;
    const generatePdfClickHandler = () => {
        if (contentParams && typeof window !== undefined) {
            // setIsLoading(true);
            tearSheetDownload({downloadtearsheet:true})
            generatePdf({
                identifier: productNumberWithOutSuffix,
                templateName: "tearsheet",
                onSuccess(result) {
                    // setIsLoading(false);
                    tearSheetDownload({downloadtearsheet:false})
                },
                onError(result) {
                    // setIsLoading(false);
                    tearSheetDownload({downloadtearsheet:false})
                    toasterContext.addToast({
                        body: translate(`${result}`),
                        messageType: "danger",
                    });
                },
            });
        }
    };
    const downloadImage = async (filePath: string) => {
        const pathFetch = await fetch(filePath);
        if (pathFetch != null) {
            const blob = await pathFetch.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${productNumberWithOutSuffix}.jpg`;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    };
    const onClickFilterSection = (_accordionExpanded: boolean) => () => {
        setAccordionExpanded(!_accordionExpanded);
    };
    return (
        <StyledWrapper {...styles.accordionContainer} className="max-width-container">
            {/* {features.length > 0 && (
                <StyledWrapper {...styles.accordianSection}>
                    <Accordion headingLevel={4}>
                        <AccordionSection title="Features" {...styles.accordian}>
                            <StyledWrapper {...styles.featuresContainer}>
                                {features?.map(feature => (
                                    <Typography variant="p">{parse(feature.htmlContent, parserOptions)}</Typography>
                                ))}
                            </StyledWrapper>
                        </AccordionSection>
                    </Accordion>
                </StyledWrapper>
            )} */}
            {productDataPoint.productContentResults.length > 1 && (
                <StyledWrapper {...styles.accordianSection}>
                    <Accordion headingLevel={4}>
                        <AccordionSection title="Details" {...styles.accordian}>
                            <StyledWrapper {...styles.featuresContainer}>
                                {parse(productDataPoint.productContentResults[1], parserOptions)}
                                {showModal && (
                                    <Modal
                                        isOpen={showModal}
                                        handleClose={handleCloseModal}
                                        {...(isViewPortrait ? styles.modalStyles : styles.modalStylesLandscape)}
                                    >
                                        <StyledWrapper>
                                            <iframe
                                                src={videoLink}
                                                width="100%"
                                                height="100%"
                                                allowFullScreen
                                                frameBorder="0"
                                            ></iframe>
                                        </StyledWrapper>
                                    </Modal>
                                )}
                            </StyledWrapper>
                        </AccordionSection>
                    </Accordion>
                </StyledWrapper>
            )}
            {((product?.documents && product.documents.length > 0) ||
                (contentParams && tearSheet && doesProductTypExists)) && (
                <StyledWrapper {...styles.accordianSection}>
                    <Accordion headingLevel={4} >
                        <AccordionSection title="Resources"  {...styles.accordian}
                              {...(isdownloadtearsheet ? { expanded: true } : { expanded: isAccordionExpanded })}
                            onTogglePanel={onClickFilterSection(isAccordionExpanded)}
                            > 
                            <StyledWrapper {...styles.resourceContainer}>
                                {product.documents?.map(doc => (
                                    // eslint-disable-next-line react/jsx-key
                                    <StyledWrapper {...styles.documentsWrapper}>
                                        <Link
                                            href="#"
                                            aria-label={doc.description || "Document Link"}
                                            className="hoverColor"
                                            {...customStyleButton.iconSecondryLightBackground}
                                            onClick={() => downloadImage(doc.filePath)}
                                        >
                                            <StyledIcon src={Download} size={15} />
                                            {doc.description === "AssemblyInstallationInstructions"
                                                ? "Assembly/Installation Instructions"
                                                : doc.description === "LineDrawings"
                                                ? "Line Drawings"
                                                : doc.description}
                                        </Link>
                                    </StyledWrapper>
                                ))}

                                {isdownloadtearsheet && (
                                    <StyledWrapper {...styles.centeringWrapper}>
                                        <LoadingSpinner {...styles.spinner} />
                                    </StyledWrapper>
                                )}

                                {!isdownloadtearsheet && contentParams && tearSheet && doesProductTypExists && (
                                    <StyledWrapper {...styles.documentsWrapper}>
                                        <Link
                                            href="#"
                                            aria-label="Download Tearsheet"
                                            {...customStyleButton.iconSecondryLightBackground}
                                            onClick={generatePdfClickHandler}
                                        >
                                            <StyledIcon src={Download} size={15} />
                                            {translate("Download Tearsheet")}
                                        </Link>
                                        {/* <ButtonWrapper {...styles.button} onClick={generatePdfClickHandler}>
                                                <StyledWrapper {...styles.download}>
                                                    <Icon src="Download" />
                                                </StyledWrapper>
                                                <StyledWrapper>
                                                    <Typography>{translate("Download Tearsheet")}</Typography>
                                                </StyledWrapper>
                                            </ButtonWrapper> */}
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        </AccordionSection>
                    </Accordion>
                </StyledWrapper>
            )}

            {/* <StyledWrapper {...styles.accordianSection}>
                <Accordion headingLevel={4}>
                    <AccordionSection title="Product Avalibility">
                        <StyledWrapper {...styles.lastUpdate}>
                            <Typography {...styles.lastUpdateLable}>(Last Updated:</Typography>
                            <Typography {...styles.lastUpdateDate}>11/8/2022 2:12:18 AM)</Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.tablediv}>
                            <DataTable>
                                <DataTableHead>
                                    <DataTableHeader>{translate("SKU")}</DataTableHeader>
                                    <DataTableHeader>{translate("Size")}</DataTableHeader>
                                    <DataTableHeader>{translate("Shipping Dimensions / Weight")}</DataTableHeader>
                                    <DataTableHeader>{translate("Quantity In-Stock")}</DataTableHeader>
                                    <DataTableHeader>{translate("Quantity Within 30 Days")}</DataTableHeader>
                                    <DataTableHeader>{translate("Quantity Within 2 Months")}</DataTableHeader>
                                    <DataTableHeader>{translate("Quantity over 2 Months")}</DataTableHeader>
                                </DataTableHead>
                                <DataTableBody>
                                    <DataTableRow>
                                        <DataTableCell>ABB2302-23</DataTableCell>
                                        <DataTableCell>2' x 3'</DataTableCell>
                                        <DataTableCell>24" x 4" x 4" 3 lbs.</DataTableCell>
                                        <DataTableCell>20</DataTableCell>
                                        <DataTableCell>0</DataTableCell>
                                        <DataTableCell>0</DataTableCell>
                                        <DataTableCell>0</DataTableCell>
                                    </DataTableRow>
                                    <DataTableRow>
                                        <DataTableCell>ABB2302-23</DataTableCell>
                                        <DataTableCell>2' x 3'</DataTableCell>
                                        <DataTableCell>24" x 4" x 4" 3 lbs.</DataTableCell>
                                        <DataTableCell>20</DataTableCell>
                                        <DataTableCell>0</DataTableCell>
                                        <DataTableCell>0</DataTableCell>
                                        <DataTableCell>0</DataTableCell>
                                    </DataTableRow>
                                    <DataTableRow>
                                        <DataTableCell>ABB2302-CStd</DataTableCell>
                                        <DataTableCell>CUSTOM (STANDARD)</DataTableCell>
                                        <DataTableCell></DataTableCell>
                                        <DataTableCell></DataTableCell>
                                    </DataTableRow>
                                    <DataTableRow>
                                        <DataTableCell>ABB2302-CStd</DataTableCell>
                                        <DataTableCell>CUSTOM (STANDARD)</DataTableCell>
                                        <DataTableCell></DataTableCell>
                                        <DataTableCell></DataTableCell>
                                    </DataTableRow>
                                </DataTableBody>
                            </DataTable>
                        </StyledWrapper>
                    </AccordionSection>
                </Accordion>
            </StyledWrapper> */}
        </StyledWrapper>
    );
};

const pdpAccordionSection: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(PdpAccordionSection)),
    definition: {
        group: "Common",
        icon: "Filter",
        displayName: "Surya PDP Accordion Section",
        fieldDefinitions: [],
    },
};

export default pdpAccordionSection;
